<template>
  <div class="rankingCell__container">
    <p v-if="shouldShowRank" class="rankingCell__containerRank">
      {{ result.rank }}
    </p>
    <div v-if="shouldShowRankImg" class="rankingCell__rankImgContainer">
      <img
        class="rankingCell__rankImg"
        :src="this.$resources.iconBadgeImage(result.rank)"
      />
    </div>
    <div>
      <div
        class="rankingCell__ImgContainer"
        :style="{
          'background-image':
            'url(' + this.$resources.iconBackgroundImage(result.rank) + ')',
        }"
      >
        <img
          :src="getIconUrl(result.icon_url, 78)"
          class="rankingCell__iconImg"
        />
      </div>
    </div>
    <p class="rankingCell__containerName">{{ result.name }}</p>
    <p class="rankingCell__containerScore">{{ commaSepalatedValue }}</p>
  </div>
</template>

<script>
import formatter from '@/utils/Formatter'
import ImgUrl from '@/utils/ImgUrl'
export default {
  name: 'AudienceRankingCell',
  props: {
    result: {
      rank: Number,
      icon_url: String,
      name: String,
      score: Number,
    },
  },
  computed: {
    shouldShowRank() {
      return this.result.rank > 3 || this.result.rank === undefined
    },
    shouldShowRankImg() {
      return this.result.rank < 4
    },
    shouldShowBackgroundImg() {
      return this.result.rank < 4
    },
    commaSepalatedValue() {
      return formatter.vliveFormat(this.result.score)
    },
  },
  methods: {
    getIconUrl: function (baseUrl, size) {
      return ImgUrl.getIconUrlWithSize(baseUrl, size)
    },
  },
}
</script>

<style scoped>
.rankingCell__container {
  display: flex;
  border-bottom: 1px solid #eeeeee;
  height: 60px;
  align-items: center;
}

.rankingCell__containerRank {
  width: 48px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.rankingCell__rankImgContainer {
  width: 48px;
  padding: 10px;
  display: flex;
  align-items: center;
}

.rankingCell__rankImg {
  width: 28px;
  height: 28px;
}

.rankingCell__iconImg {
  background-color: #e8e8e8;
}

.rankingCell__ImgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  background-size: contain;
  padding: 8px 8px 6px;
}

.rankingCell__container img {
  flex-basis: 40px;
  height: 41px;
  border-radius: 50%;
}

.rankingCell__containerName {
  flex-grow: 1;
  flex-basis: auto;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.rankingCell__containerScore {
  margin-right: 36px;
  color: #188dff;
  font-size: 12px;
  font-weight: bold;
}
</style>
